(function(module) {
        'use strict';

        function AddDisplayCtrl(Display, $state, Store, $q, $scope, $timeout) {
            this.$onInit = () => {
                this.mode = 'single';
                this.multiplePairingCodes = [];
            };

            this.pair = (pairingCode) => {
                // set sub account
                const subAccountId = Store.getCurrentSubAccountId();
                const data = {
                    pairingCode,
                };
                if (subAccountId) {
                    _.set(data, 'subAccountId', subAccountId);
                }
                const deferred = $q.defer();
                Display
                    .pairWithCode(data)
                    .$promise
                    .then((display) => {
                        return deferred.resolve({ display });
                    })
                    .catch(({ data }) => {
                        const errorMessage = {
                            pairingCode,
                            code: _.get(data, 'error.code'),
                            statusCode: _.get(data, 'error.statusCode'),
                        };
                        return deferred.resolve({ error: errorMessage });
                    });
                return deferred.promise;
            };

            this.pairSingleDisplay = () => {

                // clear custom errors
                this.errors = {};

                const pairingCode = this.pairingCode;
                this
                    .pair(pairingCode)
                    .then(({ display, error }) => {
                        if (error) {
                            console.error(error);
                            this.errors.singleErrorMessage = true;
                        }

                        if (display) {
                            Store.setSingleModelData('displays', display.id, display);
                            $state.go('root.displays.view', { id: display.id });
                        }
                    });
            };

            this.pairMultipleDisplays = () => {

                // clear custom errors
                this.errors = {};

                // create promises
                const promises = [];

                // remove all empty inputs
                const codes = _.compact(this.multiplePairingCodes);
                codes.forEach((pairingCode) => {
                    promises.push(this.pair(pairingCode));
                });

                Promise
                    .all(promises)
                    .then((results) => {
                        const errors = _.filter(results, 'error');
                        const displays = _.filter(results, 'display');

                        // if there were errors pairing, clear all codes and insert the failed ones
                        // otherwise just move one
                        if (errors.length) {
                            this.multiplePairingCodes = [];
                            const failedPairingCodes = _.map(errors, 'error.pairingCode');
                            failedPairingCodes.forEach((failedPairingCode) => {
                                this.multiplePairingCodes.push(failedPairingCode);
                            });

                            console.error(errors);
                            this.errors.multi = true;

                            if (!$scope.$$phase) {
                                $timeout(() => {
                                    $scope.$apply();
                                });
                            }
                        } else {
                            displays.forEach((display) => {
                                Store.setSingleModelData('displays', display.id, display);
                            });
                            $state.go('root.displays');
                        }
                    });

            };

            this.addDisplay = () => {
                switch (this.mode) {
                    case 'single':
                        return this.pairSingleDisplay();
                    case 'multi':
                        return this.pairMultipleDisplays();
                }
            };
        }

        module
            .config(($stateProvider) => {
                $stateProvider
                    .state('root.displays.add', {
                        url: '/add',
                        data: {
                            pageTitle: 'PLAYERS_ADD.PAGE_TITLE',
                        },
                        views: {
                            'content@root': {
                                template: '<display-add-component />',
                            },
                        },
                    });
            })
            .component('displayAddComponent', {
                templateUrl: '/js/displays/add-display/add-display.html',
                controller: AddDisplayCtrl,
            });

    }

)(angular.module('rocket.components'));
